module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.0d0267b1.xml";